import { Box } from '@chakra-ui/react';
import { SelectUser } from '@texas/components/shared/users/SelectUser';

export function AddUser({
  onClick,
  title,
  sub,
  size,
}: {
  onClick: () => void;
  title: string;
  sub: string;
  size?: 'default' | 'sm';
}) {
  return (
    <Box
      opacity={0}
      _groupHover={{ opacity: 1 }}
      transition="opacity 100ms ease"
    >
      <SelectUser title={title} sub={sub} size={size} onClick={onClick} />
    </Box>
  );
}
